const header = () => {
    const stickyTransparentHeader = document.querySelector('.header[sticky][allow-transparency]');
    if (stickyTransparentHeader) {
        const events = ['load', 'scroll'];
        events.forEach((event) => {
            window.addEventListener(event, () => {
                if (window.scrollY > 300) {
                    stickyTransparentHeader.classList.add('th-is-filled');
                }
                else {
                    stickyTransparentHeader.classList.remove('th-is-filled');
                }
            });
        });
    }
};
export { header };
